/** Internal dependencies */
import { replaceContent } from './frontendhbs/replaceContent';
import { loadAjax } from './frontendhbs/loadAjax';

if (document.readyState !== 'loading') {
    initRest();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initRest();
    });
}

function initRest() {
    // dynamic ajax content replacer
    const restCallsReplace = document.querySelectorAll('[data-rest-replace]');
    if (restCallsReplace) {
        restCallsReplace.forEach((parent) => replaceContent(parent));
    }

    // rest ajax loader
    const restCalls = document.querySelectorAll('[data-rest]');
    if (restCalls) {
        restCalls.forEach((parent) => loadAjax(parent));
    }
}
